module.exports = __webpack_public_path__ + "static/media/page11.e3328bc3.jpg";